import { Product, ProductList } from 'components/ordering/backorders/typing/product-list.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { baseUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'


export const PRODUCT_INFORMATION_FETCHER = Symbol('PRODUCT_INFORMATION_FETCHER')

export interface ProductInformationFetcher {
  getProductInformation(productId: number[], headlessEndpointUrl: string): Promise<Product[] | undefined>
}

@registerDependency(FAKE, PRODUCT_INFORMATION_FETCHER)
export class FakeProductInformationFetcher implements ProductInformationFetcher {

  products: ProductList = []

  latestRequestedProductIds: Set<number> = new Set()

  insertProduct(product: Product) {
    this.products.push(product)
  }

  async getProductInformation(productIds: number[], headlessEndpointUrl: string): Promise<Product[] | undefined> {
    headlessEndpointUrl
    this.latestRequestedProductIds = new Set(productIds)
  
    return this.products.filter(product => productIds.includes(product.id))
  }

  getLastRequestedProductIds(): Set<number> {
    return this.latestRequestedProductIds
  }
}

@registerDependency(REAL, PRODUCT_INFORMATION_FETCHER)
export class RealProductInformationFetcher implements ProductInformationFetcher {
  async getProductInformation(productIds: number[], headlessEndpointUrl: string): Promise<Product[]> {
    const params = new URLSearchParams(productIds.map(id => ['id', `${id}`]))
    const url = new URL(headlessEndpointUrl, await baseUrl())
    url.search = params.toString()

    const result = await fetch(url, {  // nosemgrep
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
    if (!result.ok) return []
    return (await result.json())
  }

}
